(function () {

    'use strict';

    angular.module('iplusjs.filter.monthName', [
        'iplusjs.utils.format'
    ])
    .filter('monthName', MonthName);

    MonthName.$inject = [
        'FormatUtilsService'
    ];
    function MonthName(FormatUtilsService) {
        return function (month) {
            return FormatUtilsService.monthToMonthName(month);
        };
    }
})();
